import React, { useMemo, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import BrandMark from '../components/BrandMark';

const ResetPassword: React.FC = () => {
  const [params] = useSearchParams();
  const token = useMemo(() => params.get('token') || '', [params]);
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 8) {
      setError('Huit caractères minimum.');
      return;
    }
    if (password !== confirm) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await axios.post('/api/auth/reset-password', { token, password });
      navigate('/login');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Lien invalide ou expiré.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-[80vh] flex items-center justify-center px-4">
        <p className="text-ink-muted">
          Lien incomplet.{' '}
          <Link to="/forgot-password" className="text-forest-700 underline">
            Demander un nouveau lien
          </Link>
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md">
        <BrandMark />
        <h1 className="font-serif text-3xl text-ink mt-8 mb-6">Nouveau mot de passe</h1>
        <form onSubmit={handleSubmit} className="card p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-ink mb-1">Mot de passe</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input" />
          </div>
          <div>
            <label className="block text-sm font-medium text-ink mb-1">Confirmation</label>
            <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input" />
          </div>
          {error && <p className="text-sm text-red-800">{error}</p>}
          <button type="submit" disabled={loading} className="btn btn-primary w-full">
            {loading ? 'Enregistrement…' : 'Mettre à jour'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
